export default __webpack_public_path__ + "static/media/Arcade Full.4df9e445.png";